import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import AuthLayout1 from '../layouts/AuthLayouts/AuthLayout1'
/* Dashboards View */
import Dashboard from '../views/Dashboards/Dashboard.vue'

/* Authentic View */
import SignIn1 from '../views/AuthPages/Default/SignIn1'
import SignUp1 from '../views/AuthPages/Default/SignUp1'
import RecoverPassword1 from '../views/AuthPages/Default/RecoverPassword1'
import LockScreen1 from '../views/AuthPages/Default/LockScreen1'
import ConfirmMail1 from '../views/AuthPages/Default/ConfirmMail1'
import ApplicationLayout from '../layouts/ApplicationLayout'
import UserView from '../views/User/UserView'
import UserAdd from '../views/User/UserAdd'
import UserList from '../views/User/UserList'
import UserDetail from '../views/User/UserDetail'
import UserActivityLog from '../views/User/UserActivityLog'
import TransactionLogList from '../views/Transaction/TransactionLogList'
import ProfileEdit from '../views/User/ProfileEdit'
import AutoReport from '../views/Report/AutoReport'
import AutoReportHttp from '../views/Report/AutoReportHttp'
import ReportList from '../views/Report/ReportList'
import CustomerList from '../views/Manage/CustomerList'
import LinkList from '../views/Manage/LinkList'
import FormularList from '../views/Manage/FormularList'
import GroupFormulaList from '../views/Manage/GroupFormulaList'
import AccountList from '../views/Manage/AccountList'
import AccountConfigList from '../views/Manage/AccountConfigList'
import DepositWithdraw from '../views/UsdtTransaction/DepositWithdraw'

Vue.use(VueRouter)

const childRoutes = (prop, mode) => [
  {
    path: '/',
    name: prop + '.home-1',
    meta: { dark: mode, auth: true, name: 'Trang chủ' },
    component: Dashboard
  }
]

const authChildRoutes = (prop, mode = false) => [
  {
    path: 'sign-in1',
    name: prop + '.sign-in1',
    meta: { dark: mode, auth: false },
    component: SignIn1
  },
  {
    path: 'sign-up1',
    name: prop + '.sign-up1',
    meta: { dark: mode, auth: false },
    component: SignUp1
  },
  {
    path: 'password-reset1',
    name: prop + '.password-reset1',
    meta: { dark: mode, auth: false },
    component: RecoverPassword1
  },
  {
    path: 'lock-screen1',
    name: prop + '.lock-screen1',
    meta: { dark: mode, auth: false },
    component: LockScreen1
  },
  {
    path: 'confirm-mail1',
    name: prop + '.confirm-mail1',
    meta: { dark: mode, auth: false },
    component: ConfirmMail1
  }
]

const profileChildRoutes = (prop, mode = false) => [
  {
    path: 'edit-profile',
    name: prop + '.edit-profile',
    meta: { dark: mode, auth: true },
    component: ProfileEdit
  }
]

const userChildRoutes = (prop, mode = false) => [
  {
    path: 'manage',
    component: UserView,
    meta: { auth: true, name: 'Thành viên' },
    children: [
      {
        path: 'add',
        name: prop + '.add',
        meta: { dark: mode, auth: true, name: 'Thêm thành viên' },
        component: UserAdd
      },
      {
        path: 'list',
        name: prop + '.list',
        meta: { dark: mode, auth: true, name: 'Danh sách thành viên' },
        component: UserList
      },
      {
        path: 'detail/:code',
        name: prop + '.detail',
        meta: { dark: mode, auth: true, name: 'Chi tiết' },
        component: UserDetail
      }
    ]
  }
]

const activityLogChildRoutes = (prop, mode = false) => [
  {
    path: 'activity-log',
    component: UserActivityLog,
    name: prop + '.list',
    meta: { auth: true, name: 'Lịch sử hoạt động' }
  }
]

const transactionLogChildRoutes = (prop, mode = false) => [
  {
    path: 'transaction-log',
    component: TransactionLogList,
    name: prop + '.list',
    meta: { auth: true, name: 'Lịch sử giao dịch' }
  }
]

const reportChildRoutes = (prop, mode = false) => [
  {
    path: 'auto',
    component: AutoReport,
    name: prop + '.auto',
    meta: { auth: true, name: 'Báo cáo tự động' }
  },
  {
    path: 'auto-http',
    component: AutoReportHttp,
    name: prop + '.auto.http',
    meta: { auth: true, name: 'Báo cáo' }
  },
  {
    path: 'list',
    component: ReportList,
    name: prop + '.list',
    meta: { auth: true, name: 'Báo cáo' }
  }
]

const manageChildRoutes = (prop, mode = false) => [
  {
    path: 'customer',
    component: CustomerList,
    name: prop + '.customer',
    meta: { auth: true, name: 'Khách hàng' }
  },
  {
    path: 'link',
    component: LinkList,
    name: prop + '.link',
    meta: { auth: true, name: 'Liên kết' }
  },
  {
    path: 'formular',
    component: FormularList,
    name: prop + '.formular',
    meta: { auth: true, name: 'Công thức' }
  },
  {
    path: 'group_formula',
    component: GroupFormulaList,
    name: prop + '.group_formula',
    meta: { auth: true, name: 'Công thức nhóm' }
  },
  {
    path: 'account',
    component: AccountList,
    name: prop + '.account',
    meta: { auth: true, name: 'Tài khoản' }
  },
  {
    path: 'account_config',
    component: AccountConfigList,
    name: prop + '.account_config',
    meta: { auth: true, name: 'Thiết lập các tài khoản' }
  }
]

const depositWithdrawRoutes = (prop, mode = false) => [
  {
    path: 'depost-withdraw',
    component: DepositWithdraw,
    name: prop + '.add',
    meta: { auth: true, name: 'Nạp rút' }
  }
]

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: ApplicationLayout,
    meta: { auth: true },
    children: childRoutes('dashboard')
  },
  {
    path: '/auth',
    name: 'auth1',
    component: AuthLayout1,
    meta: { auth: false },
    children: authChildRoutes('auth1')
  },
  {
    path: '/profile',
    name: 'profile',
    component: ApplicationLayout,
    meta: { auth: false },
    children: profileChildRoutes('profile')
  },
  {
    path: '/user',
    name: 'user',
    component: ApplicationLayout,
    meta: { auth: true },
    children: userChildRoutes('user-manage')
  },
  {
    path: '/activity-log',
    name: 'activity-log',
    component: ApplicationLayout,
    meta: { auth: true },
    children: activityLogChildRoutes('activity-log')
  },
  {
    path: '/transaction-log',
    name: 'transaction-log',
    component: ApplicationLayout,
    meta: { auth: true },
    children: transactionLogChildRoutes('transaction-log')
  },
  {
    path: '/deposit-withdraw',
    name: 'deposit-withdraw',
    component: ApplicationLayout,
    meta: { auth: true },
    children: depositWithdrawRoutes('deposit-withdraw')
  },
  {
    path: '/report',
    name: 'report',
    component: ApplicationLayout,
    meta: { auth: true },
    children: reportChildRoutes('report')
  },
  {
    path: '/manage',
    name: 'manage',
    component: ApplicationLayout,
    meta: { auth: true },
    children: manageChildRoutes('manage')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (document.getElementById('main-layout')) { document.getElementById('main-layout').scrollIntoView({ behavior: 'smooth' }) }
    }
  }
})

router.beforeEach((to, from, next) => {
  let authObj = store.getters['Auth/authUserState']

  if (to.matched.some((record) => record.meta.auth)) {
    if (authObj.logined === true) {
      next()
    } else {
      next({ path: '/auth/sign-in1' })
    }
  } else {
    if (authObj.logined === true && to.name === 'auth1.sign-in1') {
      next({ name: 'dashboard.home-1' })
    } else {
      next()
    }
  }
})

export default router
